const defaultState = {
    workflow: "empty",
    imageFile: null,
    imageBitmap: null,
    imageMeta: null,
    config: {
        tilesWide: 4,
        tilesHigh: 4,
        tileResolution: 256,
        scalingMode: "fit",
        gameId: "none"
    },
    crop: null,
    activeJobId: null,
    progressPercent: 0,
    statusMessage: "No image selected."
};

export function createStateStore(seed = {}) {
    const listeners = new Set();
    let state = {
        ...defaultState,
        ...seed,
        config: {
            ...defaultState.config,
            ...(seed.config ?? {})
        }
    };

    function getState() {
        return state;
    }

    function setState(patch) {
        state = {
            ...state,
            ...patch,
            config: {
                ...state.config,
                ...(patch.config ?? {})
            }
        };

        listeners.forEach((listener) => listener(state));
    }

    function subscribe(listener) {
        listeners.add(listener);
        return () => listeners.delete(listener);
    }

    return {
        getState,
        setState,
        subscribe
    };
}
